module.exports = __webpack_public_path__ + "04_face.bc2d2360.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer1/04_face.png
// module id = 0sl5
// module chunks = 0